<template>
  <div class="whitespace-no-wrap">
    <template v-if="totalAmount">
      {{ totalAmount | currency(booking.calculated.currency_label) }}
      <span v-if="showFees && feesAmount" class="text-muted text-sm">
        (+{{ feesAmount | currency(booking.calculated.currency_label) }})
      </span>
      <div v-if="companyPenaltyAmount" class="text-danger text-sm">
        -{{
          companyPenaltyAmount | currency(booking.calculated.currency_label)
        }}
      </div>
    </template>
    <template v-else>
      {{ $t('bookings.waiting_price_suggestions') }}
    </template>
  </div>
</template>

<script>
export default {
  name: 'BookingAmount',

  props: {
    booking: {
      type: Object,
      required: true,
    },
    showFees: {
      type: Boolean,
      default: true,
    },
    order: {
      type: Object,
      default: null,
    },
  },

  computed: {
    totalAmount() {
      const { return_booking, calculated } = this.booking
      let total = calculated.total

      // return_booking amount should be summarized too
      if (
        return_booking &&
        return_booking.status !== 'cancelled' &&
        return_booking.calculated
      ) {
        total += return_booking.calculated.total
      }

      if(calculated.vat_total && !calculated.vat_included) total += calculated.vat_total
      if(return_booking && return_booking.calculated.vat_total && !return_booking.calculated.vat_included)
        total += return_booking.calculated.vat_total

      return total
    },
    feesAmount() {
      if (!this.booking.fees_amount) {
        return 0
      }

      return this.booking.fees_amount
    },

    companyPenaltyAmount() {
      const { return_booking } = this.booking
      let total = this.booking.company_penalty_amount

      if (
        return_booking &&
        return_booking.status !== 'cancelled' &&
        return_booking.company_penalty_amount
      ) {
        total += return_booking.company_penalty_amount
      }

      return total
    },
  },
}
</script>
